import { usePaymentsReadiness } from "@/hooks/usePaymentsReadiness";
import { useTranslation } from "react-i18next";

export function PaymentTestModeBanner() {
  const { t } = useTranslation("pages");
  const { environment, ready, failures, isLoading } = usePaymentsReadiness();

  if (!environment) {
    return (
      <div className="w-full border-b border-red-300 bg-red-100 px-4 py-2 text-center text-sm text-red-800">
        {t("paymentBanner.notConfigured")}
      </div>
    );
  }

  if (environment === "sandbox") {
    return (
      <div className="w-full border-b border-orange-300 bg-orange-100 px-4 py-2 text-center text-sm text-orange-800">
        {t("paymentBanner.testMode")}{" "}
        <a
          href="https://docs.lovable.dev/features/payments#test-and-live-environments"
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium underline"
        >
          {t("paymentBanner.testModeLink")}
        </a>
      </div>
    );
  }

  // Live keys are present but something still blocks real charges.
  if (!ready && !isLoading && failures.length > 0) {
    return (
      <div className="w-full border-b border-amber-300 bg-amber-100 px-4 py-2 text-center text-sm text-amber-900">
        {t("paymentBanner.notReady", { failures: failures.map((f) => f.label).join(", ") })}
      </div>
    );
  }

  return null;
}
